import { Reveal, SectionHead } from "./Reveal";
import { Gem, Wallet, Zap, Smartphone, Target, Headphones } from "lucide-react";

const CARDS = [
  [Gem, "Premium Design", "Modern interfaces designed to make your business look professional."],
  [Wallet, "Affordable Pricing", "Professional websites without traditional agency-level pricing."],
  [Zap, "24-Hour Launch", "Eligible standard projects can be launched rapidly."],
  [Smartphone, "Mobile First", "Beautiful experience across phones, tablets and desktops."],
  [Target, "Built for Your Business", "Every website is structured around your business and customers."],
  [Headphones, "Direct Support", "Simple communication and direct support throughout the project."],
];

export const WhyFalkeen = () => (
  <section id="why" data-testid="why-section" className="relative bg-obsidian py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <SectionHead center eyebrow="Why Falkeen" title="Why Falkeen Technologies" />
      <div className="mt-16 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {CARDS.map(([Icon, title, desc], i) => (
          <Reveal key={title} delay={(i % 3) * 0.08}>
            <div
              data-testid={`why-card-${i}`}
              className="group h-full rounded-2xl border border-white/5 bg-charcoal p-8 transition-[border-color,box-shadow,transform] duration-500 hover:-translate-y-1.5 hover:border-accent/30 hover:shadow-[0_0_40px_rgba(0,229,255,0.1)]"
            >
              <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-white/10 bg-white/5 transition-colors duration-500 group-hover:border-accent/40 group-hover:bg-accent/10">
                <Icon className="h-5 w-5 text-accent" strokeWidth={1.5} />
              </div>
              <h3 className="mt-6 font-display text-base font-extrabold uppercase tracking-wide text-white">{title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-zinc-400">{desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
